import { type ReactNode } from "react";

import { atom } from "jotai";
import { ScopeProvider } from "jotai-scope";

import { type BreakdownState } from "./components/explore-budgets/budget-mix-chart/hooks/types";

export type BudgetMixChartBreakdowns = {
  selectedBreakdown: BreakdownState;
  previousBreakdown: BreakdownState;
};

type MaxPercentageSpendPerPrimaryBreakdown = Record<string, number>;

export const UNSET_PRIMARY_BREAKDOWN_KEY = "UNSET_BREAKDOWN_KEY";

const initialChartBreakdown: BreakdownState = {
  filterBy: {},
  currentBreakdownKey: UNSET_PRIMARY_BREAKDOWN_KEY,
  previousBreakdownKey: null,
  selectedHigherBreakdownValue: null,
  selectedBreakdownMonochromeColor: null,
};

export const getInitialChartState = (primaryBreakdown: string) => ({
  selectedBreakdown: {
    filterBy: {},
    currentBreakdownKey: primaryBreakdown,
    previousBreakdownKey: null,
    selectedHigherBreakdownValue: null,
    selectedBreakdownMonochromeColor: null,
  },
  previousBreakdown: {
    filterBy: {},
    currentBreakdownKey: primaryBreakdown,
    previousBreakdownKey: null,
    selectedHigherBreakdownValue: null,
    selectedBreakdownMonochromeColor: null,
  },
});

export const expandedRowsAtom = atom<number[]>([]);
export const budgetChartState = atom<BudgetMixChartBreakdowns>({
  selectedBreakdown: { ...initialChartBreakdown },
  previousBreakdown: { ...initialChartBreakdown },
});

export const maxPercentSpendPerPrimaryBreakdownAtom =
  atom<MaxPercentageSpendPerPrimaryBreakdown>(
    {} as MaxPercentageSpendPerPrimaryBreakdown,
  );

export const BudgetMixProvider = ({
  children,
}: {
  children: ReactNode[] | ReactNode;
}) => {
  return (
    <ScopeProvider atoms={[maxPercentSpendPerPrimaryBreakdownAtom]}>
      {children}
    </ScopeProvider>
  );
};
